<template>
  <div class="pb-12">
    <div class="text-select pt-3 pb-5 text-center">
      Seleccione el tipo de requerimiento correspondiente a su solicitud
      <ayuda-hover
        :texto="ayuda"
        height="auto"
        width="350px"
        icon-color="primary"
      ></ayuda-hover>
    </div>
    <v-row dense justify="center">
      <v-col
        v-for="tipo in filteredTipos"
        :key="tipo.value"
        class="px-4"
        cols="12"
        sm="6"
        :md="md"
      >
        <v-card
          outlined
          class="py-4 text-center glass-card scale-hover"
          elevation="2"
          @click="$emit('select-tipo', tipo.value)"
        >
          <v-img
            :src="require('@/assets/' + tipo.img)"
            class="mx-auto"
            eager
            contain
            width="100px"
          />
          {{ tipo.text }}
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AyudaHover from "./AyudaHover.vue";
export default {
  emits: ["select-tipo"],
  components: {
    AyudaHover,
  },
  props: {
    desarrollo: {
      type: Boolean,
      default: false,
    },
    soporte: {
      type: Boolean,
      default: false,
    },
    cotizacion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tipos: [
        {
          text: "Error de Sistema",
          img: "system/error.png",
          b_mostrar: this.soporte,
          value: 6,
          ayuda:
            "<b>Error de Sistema</b>: Errores a nivel sistema que deben ser corregidos por el equipo de soporte.",
        },
        {
          text: "Mejora de Sistema",
          img: "system/mejora.png",
          value: 19,
          b_mostrar: this.cotizacion,
          ayuda:
            "<br/><br/><b>Mejora de Sistema</b>: Cambios o mejoras que se quieren aplicar en el sistema.",
        },
        {
          text: "Desarrollo Interno",
          img: "system/dev.png",
          value: 22,
          b_mostrar: this.desarrollo,
          ayuda:
            "<br/><br/><b>Desarrollo Interno</b> : Desarrollos internos que realice la institución sobre el sistema.",
        },
      ],
      // ayuda: `

      // <br/><br/><b>Mejora de Sistema</b>: Cambios o mejoras que se quieren aplicar en el sistema.
      // <br/><br/><b>Desarrollo Interno</b> : Desarrollos internos que realice la institución sobre el sistema.

      // `,
    };
  },
  computed: {
    md() {
      return this.tipos.length > 2 ? 4 : 5;
    },
    ayuda() {
      let end =
        "<br/><br/><b>Sistema: Crono, Portal Privado, Página Web, etc.</b>";
      return this.tipos.map((t) => t.ayuda) + end;
    },
    filteredTipos() {
      return this.tipos.filter((t) => t.b_mostrar);
    },
  },
  mounted() {
    if (!this.desarrollo) this.tipos.splice(2, 1);
  },
};
</script>

<style lang="css" scoped>
.glass-card {
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.335);
  backdrop-filter: blur(10px);
  background-color: rgb(from var(--v-primary-base) r g b / 0.1);
  font-size: 20px;
  font-weight: 400;
  border: 2px solid var(--v-primary-base);
}
.text-select {
  font-size: 22px;
  font-weight: 400;
}
</style>
